import { PremiumSermon } from "../entities/PremiumSermon";

export const Search = (searchTerm: string, sermons: PremiumSermon[]):PremiumSermon[] => {
	var regex = new RegExp(searchTerm, "i");
	return sermons.filter((sermon) => {
		if (regex.test(sermon.name)) {
			return sermon;
		} else if (regex.test(sermon.shortDescription)) {
			return sermon;
		} else if (regex.test(sermon.description)) {
			return sermon;
		}
		return false;
	});
};
